<template>
  <div class="flex flex-col items-center bg-gray-900 rounded pbc-post-card mb-8">
    
    <div class="w-full bg-gray-800 bg-no-repeat flex flex-col justify-start" style="
                background-blend-mode: multiply;
                background-position: center center;
                background-size: contain;
                background-image: url('/img/PBC_Meme.svg');
                "
                >

      <div class="grow flex flex-col justify-center mb-16">
        <div class="p-10 py-3 flex flex-col flex-wrap justify-center content-center">
          <div class="z-60 mt-4">
            <h1 class="text-white font-bold text-2xl mb-2">Looking for more content?</h1>
          </div>
        </div>

        <router-link class="pbc-button mt-4 px-3 py-2 self-center w-32 flex-none text-white bg-green-400" :to='{"name":"hot"}'>
          <span class="text-lg mx-auto">View More</span>
        </router-link>
      </div>
    </div>


    </div>
  
</template>
<script>
export default {
  props:{
    cta: {
      type: String,
      default: 'Create'
    },
    parent: {
      type: String,
      default: 'root'
    },
    enableTitle: {
      type: Boolean,
      default: true
    },
    enableSecondaryCta: {
      type: Boolean,
      default: true
    },
    enableCtaButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      animation: true
    }
  },
  methods:{
    onCreate() {
      this.$eventbus.emit('create');
    },
    playAnimation() {
      this.animation = false;
      setTimeout( () => {
      this.animation = true;
      }, 100);
    }
  }
}
</script>

<style scoped>
.content-rotate2 {
transform: rotate(-34deg);
overflow: visible;
}

.content-rotate {
transform: rotate(-7deg);
overflow: visible;
}

@keyframes popup {
  0% {
    transform: translateY(150px) translateX(-200px);
  }
  34% {
    transform: translateY(120px) translateX(-80px);
  }
  37% {
    transform: translateY(70px) translateX(-40px);
  }
  100% {
    transform: translateY(0px);
  }
}

@keyframes crazy {
  0% {
    transform: translateX(100px) rotate(0deg);
  }
  30% {
    transform: translateX(0px) rotate(-34deg);
  }
  80% {
    transform: translateX(0px);
  }
  90% {
  }
  100% {
    transform: rotate(0deg);
  }
}

.play-cta-animation #ninja {
  animation: popup 0.8s 0.0s linear;
}
.play-cta-animation #smile {
  animation: crazy 0.8s 0.0s linear;
  transform-origin: 50% 50%;
}

@keyframes textbounce {
  0% {
    transform: scale(0.4, 0.4) rotate(-7deg);
  }
  30% {
    transform: scale(0.6, 0.6) rotate(-7deg);
  }
  60% {
    transform: scale(0.8, 0.8) rotate(-7deg);
  }
  100% {
    transform: scale(1.0, 1.0) rotate(-7deg);
  }
}
.play-cta-animation#cta-message {
  animation: textbounce 0.2s 0.0s ease;
}
</style>


